import { createStore } from 'zustand/vanilla'
import { useStore } from 'zustand'
import type { SplitIOStore } from '../types'

export const vanillaSplitClient = createStore<SplitIOStore>((set, get) => ({
  client: undefined,
  localFlags: {},
  isSplitTreatmentOn: (treatment) => {
    return get().localFlags?.[treatment] === 'on' || get().client?.getTreatment(treatment) === 'on'
  },
  getSplitTreatment: (treatment) => {
    return get().localFlags?.[treatment] || get().client?.getTreatment(treatment) || ''
  },
  setClient: (client) => set((state) => ({ ...state, client })),
  setLocalFlags: (localFlags) => set((state) => ({ ...state, localFlags }))
}))

export const useSplitClient = () => useStore(vanillaSplitClient)
